import { useTranslation } from 'react-i18next';

export default function WhatIsSection() {
  const { t } = useTranslation();

  return (
    <section id="what-is" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
              CSSBuy Resource Hub
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-6">
              {t('what_is_title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed text-base mb-6">
              {t('what_is_desc')}
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                {t('cta_main_button2')}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
              <a
                href="/article/cssbuy-spreadsheet-guide"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border border-background-300 text-foreground-700 text-sm font-medium rounded-md hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {t('hero_cta_guide')}
              </a>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=printed%20product%20catalog%20pages%20with%20pricing%20table%20and%20product%20photos%20spread%20on%20clean%20white%20desk%20soft%20natural%20light%20warm%20editorial%20overhead%20flatlay&width=800&height=600&seq=whatis-1&orientation=landscape&nocache=true"
                alt="CSSBuy Spreadsheet"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-lg border border-background-200/70 p-4 shadow-lg max-w-[200px]">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-2 h-2 rounded-full bg-primary-500" />
                <span className="text-xs font-medium text-foreground-700">Active Users</span>
              </div>
              <span className="font-heading text-2xl font-bold text-foreground-950">50K+</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}